module.exports = __webpack_public_path__ + "img/box66.9ce36948.png";